import * as React from 'react'
import {
  FailableAction,
  Action,
  actionCreator,
  PayloadAction,
  payloadActionCreator,
} from '@library/react-toolkit'
import { Actions as AllActions } from '../../store'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { MessageID } from '../../translations/data'

export type FailableActions = Extract<AllActions, FailableAction<any, any>>
type FailableActionTypes = FailableActions['type']

export type QueueItem = [React.ReactNode, 'success' | 'error']

export type State = QueueItem[]

export type CloseNotification = Action<'close_notification'>
export const closeNotification =
  actionCreator<CloseNotification>('close_notification')

export type ShowNotification = PayloadAction<'show_notification', QueueItem>
const showNotification =
  payloadActionCreator<ShowNotification>('show_notification')
export const showError = (msg: React.ReactNode) =>
  showNotification([msg, 'error'])
export const showSuccess = (msg: React.ReactNode) =>
  showNotification([msg, 'success'])

export const useShowError = () => {
  const dispatch = useDispatch()
  const intl = useIntl()
  return (id: MessageID) => {
    dispatch(showError(intl.formatMessage({ id })))
  }
}

export const useShowSuccess = () => {
  const dispatch = useDispatch()
  const intl = useIntl()
  return (id: MessageID) => {
    dispatch(showSuccess(intl.formatMessage({ id })))
  }
}

export type Actions = CloseNotification | ShowNotification

type ActionsLookup = Record<
  FailableActionTypes,
  {
    success?: React.ReactNode
    error?: React.ReactNode
  }
>

export const lookup: ActionsLookup = {
  'UPLOAD/send_result': {
    error: <FormattedMessage id="uploadError" />,
    success: <FormattedMessage id="uploadSuccess" />,
  },
  '@react-toolkit/logout_result': {},
  '@react-toolkit/get_account_result': {},
  '@react-toolkit/get_current_workspace_result': {
    // TODO: set messages
  },
  get_info_result: {},
  'BALANCE/get_balance_result': {
    error: <FormattedMessage id="getBalanceError" />,
  },
  'PAYERS/get_result': {
    error: <FormattedMessage id="getCustomersError" />,
  },
  'PAYERS/add_result': {
    error: <FormattedMessage id="addCustomerError" />,
    success: <FormattedMessage id="addCustomerSuccess" />,
  },
  'PAYERS/delete_result': {
    error: <FormattedMessage id="deleteCustomerError" />,
    success: <FormattedMessage id="deleteCustomerSuccess" />,
  },
  'PAYERS/edit_result': {
    error: <FormattedMessage id="editCustomerError" />,
    success: <FormattedMessage id="editCustomerSuccess" />,
  },
  'BILL/send_bill_result': {
    error: <FormattedMessage id="notificationError" />,
    success: <FormattedMessage id="notificationSuccess" />,
  },
}
